<template>
  <div class="page-header">
    <el-row type="flex">
      <el-col :span="21" class="left-panel">
        <button class="opt-btn" @click="handleExpand">
          <icon name="menu"></icon>
        </button>
        <button class="opt-btn" @click="handleRefresh">
          <icon name="refresh"></icon>
        </button>
        <el-tabs
          v-model="activeName"
          type="card"
          class="top-nav-container"
          :closable="navList.length !== 1"
          @tab-remove="handleTabRemove"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            v-for="nav in navList"
            :key="nav.name"
            :label="nav.name"
            :name="nav.name"
          ></el-tab-pane>
        </el-tabs>
      </el-col>
      <slot></slot>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '',
      factory: ''
    }
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    navList() {
      return this.$store.state.navList
    }
  },

  watch: {
    $route: function (route) {
      this.activeName = route.meta.title
    }
  },
  mounted() {
    this.activeName = this.$route.meta.title
  },
  methods: {
    handleExpand() {
      this.$emit('expand')
    },
    handleRefresh() {
      const route = this.$route
      const componentName =
        route.matched[route.matched.length - 1].components.default.name

      // 从缓存中移除当前组件
      this.$store.commit('popAliveComponent', componentName)
      // 重新导航到当前路由以刷新组件
      this.$router.replace({
        path: route.path,
        query: { ...route.query, t: Date.now() } // 添加时间戳参数以确保组件重新渲染
      })
    },
    handleBack() {
      this.$router.back()
    },

    handleTabClick({ index }) {
      this.$router.push({ path: this.navList[index].path })
    },

    handleTabRemove(name) {
      const index = this.navList.findIndex((item) => {
        return item.name === name
      })

      if (this.activeName === name) {
        if (this.navList.length - 1 > index) {
          this.$router.push({ path: this.navList[index + 1].path })
        } else if (this.navList.length !== 1) {
          this.$router.push({ path: this.navList[index - 1].path })
        }
      }

      this.$store.commit('popAliveComponent', this.navList[index].componentName)

      this.$store.commit('popNavPage', { name: name })
    }
  }
}
</script>
<style lang="scss">
@import '~@xpeng/element-styles/src/variables.scss';
@import '~@xpeng/element-styles/src/mixin.scss';

.page-header {
  @include clearfix;
  height: 49px;
  line-height: 49px;
  padding: 0 16px 0 16px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  .left-panel {
    @include clearfix;
    .opt-btn {
      float: left;
      background: none;
      border: none;
      outline: none;
      margin-right: 16px;
      height: 36px;
      width: 36px;
      text-align: center;
      padding-top: 5px;
      margin-top: 6px;
      border-radius: 50%;
      cursor: pointer;
      &:hover {
        background: #f1f3f5;
        color: $primaryColor;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      }
      svg {
        width: 16px;
        height: 16px;
      }
    }
    .refresh-btn {
      float: left;
    }
    .top-nav-container {
      float: left;
      width: calc(100% - 120px);
      overflow-x: auto;
    }
  }

  .page-back {
    text-align: right;
  }

  // el-tabs样式重置
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__nav {
    line-height: 48px;
    border: 0;
  }
  .el-tabs__nav-wrap {
    margin-bottom: 0;
  }
  .el-tabs--card > .el-tabs__header {
    border-bottom: 0;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
    box-sizing: border-box;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    margin-top: 4px;
    font-size: 14px;
    background: #eeeeee;
    margin-left: 2px;
    border-top: 3px solid transparent;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border: none;
    border-top: 3px solid $primaryColor;
    font-weight: 600;
  }
  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 48px;
  }
}
</style>
